export const getFilenameFromS3Url=(s3Url)=> {
    // Create a URL object from the S3 URL
    const url = new URL(s3Url);
    
    // Extract the path and return the last part (the file name)
    
    return url.pathname.split('/').pop()||"image";
}
